import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { bookListURL as _bookListURL } from '@/constants';
import { getManualURL } from '@/utils/manual';
import { useAuth } from '@/plugins/auth';
import { useDomain } from '@/plugins/domain';
import Icon from '@/components/renewal/common/icon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'help-menu-list',
  setup: function setup(__props) {
    var auth = useAuth();
    var domain = useDomain();
    var bookListURL = ref(_bookListURL);

    // マニュアルURL
    var manualLink = ref(null);
    var SUPPORT_URL = 'https://faq.legalscape.jp/kb-tickets/new';
    onMounted(function () {
      manualLink.value = getManualURL({
        $domain: domain,
        $auth: auth
      });
    });
    return {
      __sfc: true,
      auth: auth,
      domain: domain,
      bookListURL: bookListURL,
      manualLink: manualLink,
      SUPPORT_URL: SUPPORT_URL,
      Icon: Icon
    };
  }
});